import styled from '@emotion/styled';
import { COLORS, mediaMax, breakpoints } from 'styles';

export const Container = styled.div`
  min-height: 425px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 17px;
  padding-top: 24px;

  ${mediaMax(breakpoints.tabletXS)} {
    min-height: 0px;
    padding-top: 0px;
    margin-top: 15px;
    gap: 7px;
  }
`;

export const ButtonWrapper = styled.div`
  min-width: 225px;

  ${mediaMax(breakpoints.tabletXS)} {
    min-width: 100%;
    margin-top: 7px;
  }
`;

export const Title = styled.h1`
  font-weight: 700;
  font-size: 26px;
  line-height: 28px;
  text-align: center;
  color: ${COLORS.PRIMARY_TEXT};

  ${mediaMax(breakpoints.tabletXS)} {
    font-size: 22px;
  }
`;

export const Subtitle = styled.h2`
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  text-align: center;
  color: ${COLORS.SECONDARY_TEXT};

  ${mediaMax(breakpoints.tabletXS)} {
    font-size: 15px;
    line-height: 18px;
  }
`;
